<template>
  <div style="margin-top: 71px;">
    <div>
      <div v-if="bgUrl != null" class="page-start" :style="{ backgroundImage:'url('+bgUrl+')'}">
      </div>
      <div v-if="bgUrl == null"  class="page-start">
      </div>
      <div class="wrap">
        <my-breadcrumb :id="id"></my-breadcrumb>


        <template v-for="item of displayList">
          <div v-if="item.display === '1'" class="tmb-wrapper">
            <div class="szx-top">
              <h1 class="szx-top-title">{{ item.title }}</h1>
              <p class="szx-top-info">{{ item.subTitle }}</p>
            </div>
            <div class="szx-bottom">
              <template v-for="item2 in item.imgUrls">
                <tiny-image style="padding: 20px;" :src="item2" :class="item.imgUrls.length > 1 ? 'small-image' : ''"
                          fit="cover"></tiny-image>
              </template>
            </div>
            <div v-if="item.videos" class="szx-middle">
              <Videoplayer :mp4Url="item.videos"></Videoplayer>
            </div>
            <div class="szx-middle" v-html="item.detail">

            </div>
          </div>
          <div v-if="item.display === '2'" class="ltb-wrapper">
            <div class="ltb-left">
              <tiny-image v-if="item.imgUrls.length > 0" :src="item.imgUrls[0]" fit="cover"></tiny-image>
            </div>

            <div class="ltb-right">
              <div class="ltb-top">
                <h1 class="ltb-top-title">{{ item.title }}</h1>
                <p class="ltb-top-info">{{ item.subTitle }}</p>
              </div>

              <div v-if="item.videos" class="ltb-bottom">
                <Videoplayer :mp4Url="item.videos"></Videoplayer>
              </div>

              <div class="ltb-bottom" :class="item.detail | detailLineHeight"
                   v-html="item.detail">
            </div>
            </div>
          </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import {
  Layout as TinyLayout,
  Row as TinyRow,
  Col as TinyCol,
  Image,
  Button,
  Breadcrumb,
  BreadcrumbItem
} from '@opentiny/vue'
import axios from "axios";
import MyBreadcrumb from "@/components/MyBreadcrumb.vue";
import request from "@/utils/request";
import Videoplayer from '@/components/Video';

export default {
  name: "Template1",
  components: {
    Videoplayer,
    MyBreadcrumb,
    TinyLayout,
    TinyRow,
    TinyCol,
    TinyImage: Image,
    TinyButton: Button,
    TinyBreadcrumb: Breadcrumb,
    TinyBreadcrumbItem: BreadcrumbItem
  },
  data() {
    return {
      sourceList: [],
      bgUrl: '',

      id: '',
      breadcrumbs: [],
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function (to, from) {
        this.init(to.query.id.toString());
      }
    }
  },
  created() {

  },
  computed: {
    displayList(){
      let res =  this.sourceList.map(x => {
        x.imgUrls = x.imgUrls ? x.imgUrls.split(",") : [];
        return x;
      });
      console.log(res)
      return res;
    },
  },
  filters:{
    detailLineHeight(detail){
      if (detail) {
        let length = detail.match(/<p>/g).length;
        if (length > 8) {
          return 'detail-line-height-1'
        }
      }
      return '';
    }
  },
  mounted() {
  },
  methods: {
    init(id) {
      this.id = id;
      this.queryTemplate1();
    },

    async queryTemplate1() {
      const {data} = await request.get("/outSiteMenu/queryTemplate1/" + this.id)
      this.sourceList = data.data.list;
      this.bgUrl = data.data.bgUrl;
    },
  }
};
</script>

<style scoped>

.wrap {
  max-width: 1180px;
  text-align: center;
  min-height: 300px;
  margin: 0 auto;
}

.tmb-wrapper {
  margin: 0 auto;
  padding: 100px 0;
  line-height: 2rem;
  border-bottom: 1px solid #e2e2e2;;
}


.szx-top-title {
  position: relative;
  display: inline-block;
  margin: 0 auto 20px;
  line-height: 30px;
  padding: 0 30px;
  font-weight: 400;
  font-size: 28px;
}

.szx-top-title::before {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_r.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  left: 100%;
}

.szx-top-title::after {
  content: "";
  width: 66px;
  height: 13px;
  background: url(../assets/images/n1_l.png) no-repeat center;
  background-size: contain;
  position: absolute;
  top: 5px;
  right: 100%;
}

.page-start {
  background: url(~@/assets/images/about-us-start.jpg) no-repeat center;
  background-size: 100% 100%;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  aspect-ratio: 4.8;
}

.szx-top-info {
  color: #9c9c9c;
  line-height: 2rem;
}

.szx-middle {
  margin: 0 auto;
  text-align: left;
}

.szx-bottom {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.szx-bottom >>> .tiny-image {
  /*max-height: 500px;*/
  width: 600px;
}

.small-image {
  width: 390px!important;
}


.breadcrumb {
  text-align: left;
  padding-top: 20px;
}

.tiny-breadcrumb {
  --ti-breadcrumb-font-size: 14px;
}



.ltb-wrapper{
  display: flex;
  min-height: 500px;
  margin: 0 auto;
  padding: 100px 0;
  border-bottom: 1px solid #e2e2e2;;
}

.ltb-left{
  width: 350px;
  height: 350px;
}

.ltb-right {
  flex: 1;
  text-align: left;
  padding-left: 40px;
}

.ltb-top{

}

.ltb-top-title{
  font-weight: 400;
  font-size: 28px;
  color: #214b85;
}

.ltb-top-info{
  font-size: 12px;
  color: #9c9c9c;
  line-height: 2rem;
}

.ltb-bottom{
  line-height: 2rem;
}

.detail-line-height-1{
  line-height: 1rem!important;
}
</style>
